import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Avatar from '@/components-latest/primitives/Avatar'
import { getCampaignItemPriceLabel } from '@/ducks/campaigns/campaigns.helpers'
import type { CampaignItemDetail } from '@/ducks/campaigns/campaigns.types'
import { selectCurrencySymbol } from '@/ducks/store/selectors/store.selectors'

import Styles from './CampaignDetailsModal.module.scss'

type Props = {
  item?: CampaignItemDetail
  quantity?: number
  showQuantity?: boolean
}

const CampaignDetailsItemRow = ({
  item,
  quantity,
  showQuantity = false
}: Props) => {
  const { t } = useTranslation()
  const currency = useSelector(selectCurrencySymbol) || ''
  const priceLabel = getCampaignItemPriceLabel(item, currency, t)
  const displayQuantity = quantity ?? item?.quantity

  return (
    <div className={Styles.itemRow}>
      {showQuantity && (
        <div className={Styles.quantityColumn}>
          <span className={Styles.quantityLabel}>
            {t('marketing.campaigns.details.quantity')}
          </span>
          <span className={Styles.quantityValue}>
            {displayQuantity != null ? `x${displayQuantity}` : '--'}
          </span>
        </div>
      )}
      <div className={Styles.itemImage}>
        <Avatar
          image={item?.image}
          squared
          size="medium"
          string={item?.name}
        />
      </div>
      <div className={Styles.itemInfo}>
        {item?.categoryPath && (
          <span className={Styles.categoryPath}>{item.categoryPath}</span>
        )}
        <span className={Styles.itemName}>{item?.name ?? '--'}</span>
        <span className={Styles.itemPrice}>
          {priceLabel.primary}
          {priceLabel.secondary && (
            <>
              {' '}
              <span className={Styles.originalPrice}>
                {priceLabel.secondary}
              </span>
            </>
          )}
        </span>
      </div>
    </div>
  )
}

export default CampaignDetailsItemRow
